import * as React from "react";
import {
  EditComponent,
  CreateComponent,
  CustomComponentProps,
} from "src/components/common/Component";

export function FaqEditComponent(props: CustomComponentProps) {
  const { children } = props;
  return <EditComponent attributes={["question"]} children={children} />;
}

export function FaqCreateComponent(props: CustomComponentProps) {
  const { children } = props;
  return <CreateComponent source={"faq"} children={children} />;
}
